import { render, staticRenderFns } from "./ManageNotifications.vue?vue&type=template&id=7c44b598&scoped=true&"
import script from "./ManageNotifications.vue?vue&type=script&lang=js&"
export * from "./ManageNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ManageNotifications.vue?vue&type=style&index=0&id=7c44b598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44b598",
  null
  
)

export default component.exports